import { GiftIcon, ArrowRightIcon } from "@heroicons/react/outline";
import firebase from "firebase/app";
import { useTranslation } from "next-i18next";
import { useState } from "react";

import { AnalyticsEventEnum } from "@/consts/AnalyticsEventEnum";
import { Text } from "@/features/common/components/tailwind/Text";
import { TipsConfirmDialog } from "@/features/tips/components/TipsConfirmDialog";
import { Post } from "@/generated/generated-hooks";

type PostTipsProps = {
  post: Post;
};

export const PostTips = ({ post }) => {
  const { t } = useTranslation("post");
  const { _id } = post;
  const [open, setOpen] = useState(false);
  // @todo: TRPC tips function
  // param : post id,
  const onDialogClick = () => {
    setOpen(true);
    firebase.analytics().logEvent(AnalyticsEventEnum.TipsDialogOpen);
  };
  return (
    <>
      <TipsConfirmDialog
        open={open}
        onClose={() => {
          setOpen(false);
        }}
      />
      <div
        onClick={onDialogClick}
        className="bg-primary-200 text-primary-700 flex p-1.5 gap-1 touchable"
      >
        <GiftIcon width={18} height={18} className="mt-0.5" />
        <div className="flex flex-col md:flex-row justify-between w-full gap-2.5">
          <Text size="normal">{t("post:tips.description")}</Text>
          <Text size="normal" className="flex gap-1 items-center">
            {t("post:tips.button")}
            <ArrowRightIcon width={18} height={18} />
          </Text>
        </div>
      </div>
    </>
  );
};
